import React from 'react';

interface Props {
  cumulative: boolean;
  onChange: (cumulative: boolean) => void;
}

// Daily ↔ running-total switch for the trend charts.
const SeriesModeToggle: React.FC<Props> = ({ cumulative, onChange }) => (
  <div className="inline-flex rounded-md border border-gray-200 p-0.5">
    {[false, true].map((c) => (
      <button
        key={String(c)}
        onClick={() => onChange(c)}
        className={`px-2.5 py-1 text-xs font-medium rounded ${
          cumulative === c ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'
        }`}
      >
        {c ? 'Cumulative' : 'Daily'}
      </button>
    ))}
  </div>
);

export default SeriesModeToggle;
